import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

function Floor2K5() {
  const [isHovered, setIsHovered] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();
  const imageRef = useRef(null);
  const customFloorUrl = '2'

  useEffect(() => {
    let stopTimeout;
    const delay = setTimeout(() => {
      setIsHovered(true);
      stopTimeout = setTimeout(() => {
        setIsHovered(false);
      }, 300);
    }, 3200);

    return () => {
      clearTimeout(delay);
      if (stopTimeout) clearTimeout(stopTimeout);
    };
  }, []);


  // Detect screen size to adjust behavior
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  // Handle clicking outside to reset hover effect on mobile
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (imageRef.current && !imageRef.current.contains(event.target)) {
        setIsHovered(false);
        setIsClicked(false);
      }
    };

    if (isMobile && isClicked) {
      document.addEventListener("click", handleClickOutside);
    } else {
      document.removeEventListener("click", handleClickOutside);
    }

    return () => document.removeEventListener("click", handleClickOutside);
  }, [isMobile, isClicked]);

  const handleClick = () => {
    if (isMobile) {
      if (!isClicked) {
        setIsHovered(true); // First tap acts as hover
        setIsClicked(true);
      } else {
        navigate("/second-floor", { state: { customFloorUrl } }); // Second tap navigates
      }
    } else {
      navigate("/second-floor", { state: { customFloorUrl } }); // Directly navigate on laptop
    }
  };

  return (
    <>
      {/* Green Overlay (Shown on Hover or Click for Mobile) */}
      <img
        ref={imageRef}
        className={`absolute w-[33.85vw] left-[23.65vw] top-[37.4vw] cursor-pointer transition-opacity duration-300 ${isHovered ? "opacity-100" : "opacity-0"
          }`}
        src="/images/click/clickable-images/Floors/Floor2-K5-Green.png"
        alt=""
        onMouseEnter={() => !isMobile && setIsHovered(true)} // Hover effect for laptop
        onMouseLeave={() => !isMobile && setIsHovered(false)} // Only reset hover on laptop
        onClick={handleClick} // Click-to-hover for mobile
      />

      {/* Tooltip on Hover or Click (for Mobile) */}
      {isHovered && (
        <span className="absolute left-[57.5vw] top-[37vw] bg-[#192929] montserrat font-medium text-white text-xs md:text-base px-2 lg:px-4 py-2 lg:py-3 shadow-md">
          Kati 2
        </span>
      )}
    </>
  );
}

export default Floor2K5;
